import Image from 'next/legacy/image';

import { H3, H4 } from '@common/headline';
import { TakeOurQuizCTA } from '@components/Hero/TakeOurQuizCTA';

import AtAGlanceGraphic from '@public/img/medically-supported/at-a-glance.png';

type Props = {
  utmCampaign?: string;
  utmMedium?: string;
  utmSource?: string;
};

export const AtAGlanceSection = ({
  utmCampaign,
  utmMedium,
  utmSource,
}: Props): JSX.Element => (
  <div className="flex h-[670px] justify-center bg-dawn-blue-100 md:h-[621px] md:px-[60px]">
    <div className="flex flex-col md:h-[621px] md:w-[1292px] md:flex-row md:justify-between">
      <div className="mx-auto mt-8 flex h-full max-h-[300px] w-full max-w-[580px] flex-auto px-4 md:mt-0 md:max-h-screen md:w-[426px] md:basis-2/5">
        <div className="flex w-[100%]">
          <div className="relative w-[100%]">
            <Image
              src={AtAGlanceGraphic}
              alt={'At a Glance graphic'}
              layout="fill"
              objectFit="contain"
              placeholder="blur"
            />
          </div>
        </div>
      </div>
      <div className="mt-5 flex-auto justify-end md:mt-[60px] md:flex md:basis-3/5 md:pl-4">
        <div className="flex max-w-[375px] flex-col justify-center text-blue lg:max-w-[619px]">
          <div className="px-3 text-left md:px-0">
            <div className="mb-4 text-purple">
              <H4>At a glance</H4>
            </div>
            <H3>
              95% of people who try to lose weight, put it back on again within
              one year. Stop dieting. Start Second Nature.
            </H3>
          </div>
          <div className="static inset-x-4 bottom-[48px] z-10 mb-6 mt-[32px] w-full justify-center px-3 md:flex md:justify-start md:px-0">
            <TakeOurQuizCTA
              ctaText="Check my eligibility"
              location="At a Glance"
              utmMedium={utmMedium}
              utmCampaign={utmCampaign}
              utmSource={utmSource}
              isGlp1
            />
          </div>
        </div>
      </div>
    </div>
  </div>
);
